const identity = (value) => String(value ?? '').trim();

export const getMiniStoryboardHistoryKey = (projectId, episodeId, segment) => [
  identity(projectId),
  identity(episodeId),
  identity(segment?.id),
  identity(segment?.segmentIndex),
].join(':');

export const matchesMiniStoryboardHistoryItem = (item, projectId, episodeId, segment) => {
  if (!item || !segment?.segmentIndex) return false;
  const itemProjectId = identity(item.projectId);
  const itemEpisodeId = identity(item.episodeId);
  const itemSegmentId = identity(item.segmentId);
  const itemSegmentIndex = identity(item.segmentIndex);
  if (!itemSegmentId && !itemSegmentIndex) return false;
  if (itemProjectId && itemProjectId !== identity(projectId)) return false;
  if (itemEpisodeId && itemEpisodeId !== identity(episodeId)) return false;
  // Reordering changes segmentIndex, while historical task.shotNumber keeps its old value.
  // Prefer the stable segment ID; use the index only for legacy tasks without an ID.
  if (itemSegmentId) return itemSegmentId === identity(segment.id);
  return itemSegmentIndex === identity(segment.segmentIndex);
};
